import { render, staticRenderFns } from "./notData.vue?vue&type=template&id=6d610090&scoped=true&"
import script from "./notData.vue?vue&type=script&lang=js&"
export * from "./notData.vue?vue&type=script&lang=js&"
import style0 from "./notData.vue?vue&type=style&index=0&id=6d610090&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d610090",
  null
  
)

export default component.exports